import { useGameSelector } from '../../GameStore';

export const useGameConfigSlice = {
  getBroadcasterWsAddress: (): string => {
    return useGameSelector(({ gameConfig }) => gameConfig?.broadcasterWsAddress);
  },
  getAamsTicket: (): string | null => {
    return useGameSelector(({ gameConfig }) => gameConfig?.aamsTicket);
  },
  getAamsSessionId: (): string | null => {
    return useGameSelector(({ gameConfig }) => gameConfig?.aamsSessionId);
  },
  getPerPayoutBetMaxLimit: (): number => {
    return useGameSelector(({ gameConfig }) => gameConfig?.perPayoutBetMaxLimit ?? 0);
  },
  getCustomMultiplierCap: (): number => {
    return useGameSelector(({ gameConfig }) => gameConfig?.customMultiplierCap ?? 100);
  },
  getSubtitlesAvailable: (): boolean => {
    return useGameSelector(({ gameConfig }) => gameConfig?.subtitlesAvailable);
  },
  getMaxMultiplier: (): number => {
    return useGameSelector(({ gameConfig }) => gameConfig?.maxMultiplier ?? 1000000);
  },
};
